import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";

export function UpdateFreespinsBetbarCommand() {
    const game = GameState.getCurrentGame();

    Components.betBar.setTotalFreespins(game.getTotalFreespinsWon());
    Components.betBar.setFreespinsPlayed(Math.max(0, game.getFreespinsPlayed() + 1));
}
